
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitovadodara() {



  const cardData =
  {
    keyword: 'Mumbai to Vadodara Taxi Service',
    heading: 'AB Ghule Cabs: Mumbai to Vadodara Taxi Service',
    headingDescription: 'Travel comfortably from Mumbai to Vadodara with AB Ghule Cabs’ Mumbai to Vadodara Taxi Service. Whether you are going for business, leisure, or a family trip, we ensure a smooth and enjoyable ride. With our fleet of well-maintained vehicles and experienced drivers, you can relax while we take care of the journey. Book your taxi today for a hassle-free experience.  Vadodara is approximately 400 km from Mumbai.',

    top: 'Top Places to Visit in Vadodara with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Laxmi Vilas Palace",
          description: "The grand Laxmi Vilas Palace is a must-see in Vadodara. Built in the Indo-Saracenic style, this opulent palace offers a glimpse into the royal lifestyle of the Maratha rulers. It also houses a beautiful garden and museum."
        },
        {
          title: "Sayaji Garden",
          description: "A sprawling garden that provides a refreshing break, Sayaji Garden is the perfect place to unwind. With a lake, zoo, and multiple attractions within its boundaries, it is an ideal spot for nature lovers and families."
        },
        {
          title: "Mandvi Gate",
          description: "A historic landmark, Mandvi Gate is one of the original city gates of Vadodara. It offers a glimpse into the city’s past and is a great place for history enthusiasts to explore."
        },
        {
          title: "Baroda Museum and Picture Gallery",
          description: "Located in the Sayaji Garden, this museum is home to an impressive collection of sculptures, ancient artifacts, and artwork. It’s a must-visit for those interested in Vadodara's history and culture."
        },
        {
          title: "Khanderao Market",
          description: "A bustling market in the heart of Vadodara, Khanderao Market is known for its vibrant atmosphere and array of local goods, including spices, textiles, and handicrafts. It's perfect for shopping and immersing yourself in the local culture."
        },
        {
          title: "Sur Sagar Lake",
          description: "Sur Sagar Lake is a peaceful oasis located in the city center. A lovely spot to relax by the water, it also features a large statue of Lord Shiva, making it a popular spot for both locals and tourists."
        },
        {
          title: "Kirti Mandir",
          description: "Built in honor of the Gaekwad family, Kirti Mandir is an important historical and architectural site. The temple is known for its intricate carvings and beautiful design, making it a popular tourist destination."
        },
        {
          title: "Champaner-Pavagadh Archaeological Park",
          description: "A UNESCO World Heritage Site, this archaeological park is home to ancient temples, forts, and other historical sites. It’s an excellent destination for history buffs and nature enthusiasts alike."
        },
        {
          title: "Sardar Patel Planetarium",
          description: "Located within the city, the Sardar Patel Planetarium offers an educational and fascinating experience with its astronomy exhibitions and interactive shows. A great stop for science enthusiasts and families."
        },
        {
          title: "Narmada Canal",
          description: "A scenic canal that runs through the city, the Narmada Canal provides an ideal setting for a leisurely walk or boat ride. It's an excellent place to enjoy a peaceful afternoon amidst nature."
        }
      ],


   services: [
  {
    "name": "Mumbai to Vadodara Taxi",
    description: "Looking for a taxi from Mumbai to Vadodara? AB Ghule Cabs offers reliable and affordable taxi services for a comfortable journey between Mumbai and Vadodara. Our well-maintained vehicles and experienced drivers ensure a smooth and enjoyable ride."
  },
  {
    "name": "Mumbai to Vadodara Cab",
    description: "Book a cab from Mumbai to Vadodara with AB Ghule Cabs. We offer convenient and comfortable cab services to make your journey hassle-free. Whether you're traveling for business or leisure, we ensure a safe and pleasant experience."
  },
  {
    "name": "Mumbai to Vadodara Taxi Fare",
    description: "Check out the competitive Mumbai to Vadodara taxi fare with AB Ghule Cabs. We offer transparent pricing with no hidden charges, ensuring you get the best value for your trip. Our professional drivers will ensure a comfortable and timely ride."
  },
  {
    "name": "Vadodara to Mumbai Taxi Fare",
    description: "Traveling from Vadodara to Mumbai? AB Ghule Cabs offers competitive and transparent taxi fares. Whether you're booking a one-way trip or round trip, we ensure comfortable and affordable travel with no hidden fees."
  },
  {
    "name": "Vadodara to Mumbai Airport Cab",
    description: "Need a taxi from Vadodara to Mumbai Airport? AB Ghule Cabs provides reliable and timely taxi services for airport transfers. Our well-maintained vehicles and professional drivers ensure that you reach the airport on time, without any stress."
  },
  {
    "name": "Vadodara to Mumbai Taxi",
    description: "Choose AB Ghule Cabs for your taxi ride from Vadodara to Mumbai. Our comfortable and spacious cabs are ideal for long-distance travel. We offer affordable rates and excellent service to ensure a smooth journey."
  },
  {
    "name": "One Way Cab Vadodara to Mumbai",
    description: "Looking for a one-way cab from Vadodara to Mumbai? AB Ghule Cabs offers one-way taxi services for your convenience. Our drivers ensure a safe and efficient journey from Vadodara to Mumbai, without the hassle of round-trip travel."
  },
  {
    "name": "Mumbai to Baroda Taxi Fare",
    description: "AB Ghule Cabs provides affordable Mumbai to Baroda taxi fare. We offer competitive pricing, ensuring that you have a comfortable and economical ride. Our professional drivers are committed to providing a smooth journey between the two cities."
  },
  {
    "name": "Taxi from Mumbai Airport to Vadodara",
    description: "Book a taxi from Mumbai Airport to Vadodara with AB Ghule Cabs. Our airport transfer service ensures you reach your destination comfortably and on time. We provide affordable rates, well-maintained vehicles, and professional drivers for your convenience."
  },
  {
    "name": "One Way Taxi from Mumbai to Vadodara",
    description: "AB Ghule Cabs offers one-way taxi services from Mumbai to Vadodara. Whether you're traveling for business or leisure, our one-way cab service ensures a hassle-free and comfortable journey with transparent pricing."
  },
  {
    "name": "Cab from Vadodara to Mumbai",
    description: "Need a cab from Vadodara to Mumbai? AB Ghule Cabs offers comfortable and affordable cab services for this journey. Our well-maintained vehicles and experienced drivers ensure a smooth and pleasant ride."
  },
  {
    "name": "Vadodara to Mumbai Airport One Way Cab",
    description: "Traveling from Vadodara to Mumbai Airport? Book a one-way cab with AB Ghule Cabs for a reliable airport transfer. We provide timely service, ensuring you reach the airport without stress."
  },
  {
    "name": "Mumbai to Vadodara Car Rental",
    description: "AB Ghule Cabs offers car rental services for your trip from Mumbai to Vadodara. Choose from a range of vehicles that suit your comfort and budget. Our professional drivers ensure a safe and enjoyable journey."
  },
  {
    "name": "Mumbai to Baroda Cab Price",
    description: "Check out the Mumbai to Baroda cab price with AB Ghule Cabs. We offer competitive pricing with no hidden charges, ensuring you get great value for your money. Enjoy a comfortable and convenient ride between the two cities."
  },
  {
    "name": "Mumbai to Baroda One Way Cab",
    description: "Looking for a one-way cab from Mumbai to Baroda? AB Ghule Cabs offers affordable and reliable one-way taxi services. Our drivers will ensure a smooth and timely journey for you, with no hassle of returning."
  },
  {
    "name": "One Way Taxi from Vadodara to Mumbai",
    description: "AB Ghule Cabs offers one-way taxi services from Vadodara to Mumbai. Whether you’re traveling for work or leisure, our one-way cab service ensures that you have a comfortable and timely journey with professional drivers."
  },
  {
    "name": "Vadodara to Mumbai Car Rental",
    description: "Rent a car from Vadodara to Mumbai with AB Ghule Cabs. Our car rental services offer flexibility and comfort for your journey. Choose from a range of vehicles and enjoy a smooth ride with our experienced drivers."
  },
  {
    "name": "One Way Cab Vadodara to Mumbai Airport",
    description: "Book a one-way cab from Vadodara to Mumbai Airport with AB Ghule Cabs. Our timely and reliable airport transfer services ensure that you reach the airport comfortably and on time."
  },
  {
    "name": "Vadodara to Mumbai Taxi Service",
    description: "AB Ghule Cabs provides a convenient and reliable taxi service from Vadodara to Mumbai. Our well-maintained vehicles and experienced drivers ensure that you have a safe and enjoyable ride."
  },
  {
    "name": "Pune to Mumbai Taxi Fare",
    description: "Looking for a taxi from Pune to Mumbai? AB Ghule Cabs offers affordable and reliable taxi services. We provide transparent pricing with no hidden charges, ensuring a smooth and comfortable journey."
  },
  {
    "name": "Airport Taxi Mumbai",
    description: "Book an airport taxi in Mumbai with AB Ghule Cabs. We offer timely and affordable airport transfer services to ensure you reach the airport or your destination in a hassle-free manner."
  },
  {
    "name": "Best Taxi Service in Mumbai",
    description: "AB Ghule Cabs offers the best taxi service in Mumbai. Whether you're traveling within the city or going on a long-distance trip, our well-maintained vehicles and professional drivers ensure a comfortable and reliable service."
  },
  {
    "name": "Mumbai to Vadodara Taxi Contact Number",
    description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Mumbai to Vadodara Taxi. We ensure a smooth and enjoyable ride for all our customers."
  }
],

tableData: [
    ["- Mumbai to Vadodara taxi", "- Mumbai to Vadodara cab"],
    ["- Mumbai to Vadodara taxi fare", "- Vadodara to Mumbai taxi fare"],
    ["- Vadodara to Mumbai airport cab", "- Vadodara to Mumbai taxi"],
    ["- One way cab Vadodara to Mumbai", "- Mumbai to Baroda taxi fare"],
    ["- Taxi from Mumbai airport to Vadodara", "- One way taxi from Mumbai to Vadodara"],
    ["- Cab from Vadodara to Mumbai", "- Vadodara to Mumbai airport one way cab"],
    ["- Mumbai to Vadodara car rental", "- Mumbai to Baroda cab price"],
    ["- Mumbai to Baroda one way cab", "- One way taxi from Vadodara to Mumbai"],
    ["- Vadodara to Mumbai car rental", "- One way cab Vadodara to Mumbai airport"],
    ["- Vadodara to Mumbai taxi service", "- Pune to Mumbai taxi fare"],
    ["- Airport taxi Mumbai", "- Best taxi service in Mumbai"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Professional Service",
      WhyChoosedescription: "At AB Ghule Cabs, we provide reliable and professional taxi services for your journey from Mumbai to Vadodara. Our drivers are experienced, courteous, and dedicated to ensuring a smooth and comfortable ride."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "We offer round-the-clock availability for your Mumbai to Vadodara taxi needs. Whether you're traveling during the day or night, our customer service team is ready to assist you in booking a cab at any time."
    },
    {
      WhyChooseheading: "Affordable Rates",
      WhyChoosedescription: "Our pricing is competitive, with transparent fare structures. Whether you're booking a one-way or round-trip ride from Mumbai to Vadodara, we offer affordable rates without any hidden charges."
    },
    {
      WhyChooseheading: "Comfortable and Well-Maintained Fleet",
      WhyChoosedescription: "We ensure that all our vehicles are clean, well-maintained, and regularly inspected for safety. Choose from a variety of vehicles, including sedans and SUVs, to make your long journey comfortable."
    },
    {
      WhyChooseheading: "Safe and Smooth Ride",
      WhyChoosedescription: "The safety of our passengers is a top priority. Our experienced drivers are thoroughly background-checked, ensuring that you have a safe and stress-free journey from Mumbai to Vadodara."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking your Mumbai to Vadodara taxi is simple and convenient. You can book your ride online via our website, through our mobile app, or by calling our customer service."
    },
    {
      WhyChooseheading: "Customer Satisfaction",
      WhyChoosedescription: "Our commitment to customer satisfaction is reflected in our numerous positive reviews. We strive to provide an exceptional experience, making your journey comfortable, on-time, and hassle-free."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a Mumbai to Vadodara taxi with AB Ghule Cabs?',
      answer: 'You can book your taxi online through our website, mobile app, or by calling our customer service helpline. We make the booking process quick and easy.',
    },
    {
      id: 'FAQ2',
      question: 'How long does the journey from Mumbai to Vadodara take?',
      answer: 'The journey from Mumbai to Vadodara typically takes around 6 to 8 hours, depending on traffic conditions and the route taken.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for the Mumbai to Vadodara taxi service?',
      answer: 'We offer a variety of vehicles, including sedans, SUVs, and luxury cars, ensuring a comfortable ride for both solo travelers and groups.',
    },
    {
      id: 'FAQ4',
      question: 'Are your drivers experienced and trustworthy?',
      answer: 'Yes, all our drivers are highly experienced, professional, and background-checked to ensure your safety and comfort during the trip.',
    },
    {
      id: 'FAQ5',
      question: 'What is the cost of a Mumbai to Vadodara taxi ride?',
      answer: 'The cost of your taxi ride depends on the vehicle type, route, and duration of the journey. For a precise quote, please contact our customer service team or use our online booking platform.',
    },
    {
      id: 'FAQ6',
      question: 'Do you offer round-trip services for Mumbai to Vadodara?',
      answer: 'Yes, we offer both one-way and round-trip services for Mumbai to Vadodara. You can choose the option that best suits your travel plans.',
    },
    {
      id: 'FAQ7',
      question: 'How do I pay for my Mumbai to Vadodara taxi ride?',
      answer: 'Payment can be made via cash, credit/debit card, or online payment through our app or website, providing you with flexibility and convenience.',
    },
    {
      id: 'FAQ8',
      question: 'Can I modify or cancel my booking for the Mumbai to Vadodara taxi?',
      answer: 'Yes, you can modify or cancel your booking through our website or app. Our customer service team is also available to assist with any changes.',
    },
    {
      id: 'FAQ9',
      question: 'Are there any additional charges for tolls or detours during the journey?',
      answer: 'Additional charges may apply for tolls, detours, or extended travel time, but we ensure transparency in pricing, and any extra charges will be communicated to you in advance.',
    },
    {
      id: 'FAQ10',
      question: 'Why should I choose AB Ghule Cabs for my Mumbai to Vadodara taxi?',
      answer: 'AB Ghule Cabs stands out for its reliable service, experienced drivers, well-maintained fleet, and affordable pricing. We focus on providing you with a comfortable, safe, and punctual journey.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Ramesh Patel",
      feedback: "I recently booked a Mumbai to Vadodara taxi with AB Ghule Cabs, and I couldn't be happier with the service. The driver was professional, and the car was clean and comfortable. The journey was smooth, and we arrived on time. Highly recommend them for long-distance travel!",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Neha Mehta",
      feedback: "AB Ghule Cabs made our Mumbai to Vadodara trip a pleasant experience. The driver was punctual, friendly, and knew the route well. The ride was comfortable, and the service was excellent. Will definitely use their service again!",
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Mumbai to Vadodara Taxi | Vadodara to Mumbai Taxi</title>
  <meta name="description" content="Book affordable Mumbai to Vadodara taxi services, offering one-way and round-trip options. Get the best prices for taxi services from Mumbai to Vadodara, Vadodara to Mumbai, and airport transfers." />
  <meta name="keywords" content="Mumbai to Vadodara Taxi, Mumbai to Vadodara Cab, Mumbai to Vadodara Taxi Fare, Vadodara to Mumbai Taxi Fare, Vadodara to Mumbai Airport Cab, Vadodara to Mumbai Taxi, One Way Cab Vadodara to Mumbai, Mumbai to Baroda Taxi Fare, Taxi from Mumbai Airport to Vadodara, One Way Taxi from Mumbai to Vadodara, Cab from Vadodara to Mumbai, Vadodara to Mumbai Airport One Way Cab, Mumbai to Vadodara Car Rental, Mumbai to Baroda Cab Price, Mumbai to Baroda One Way Cab, One Way Taxi from Vadodara to Mumbai, Vadodara to Mumbai Car Rental, One Way Cab Vadodara to Mumbai Airport, Vadodara to Mumbai Taxi Service, Pune to Mumbai Taxi Fare, Airport Taxi Mumbai, Best Taxi Service in Mumbai" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Mumbai to Vadodara Taxi | Vadodara to Mumbai Taxi" />
  <meta property="og:description" content="Book affordable Mumbai to Vadodara taxi services, offering one-way and round-trip options. Get the best prices for taxi services from Mumbai to Vadodara, Vadodara to Mumbai, and airport transfers." />
  <meta property="og:image" content="https://abghulecabs.com/images/mumbai-vadodara-taxi.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/mumbai-vadodara-taxi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs",
        description: "Book affordable Mumbai to Vadodara taxi services, offering one-way and round-trip options. Get the best prices for taxi services from Mumbai to Vadodara, Vadodara to Mumbai, and airport transfers.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Mumbai, Maharashtra",
          "addressLocality": "Mumbai",
          "addressRegion": "Maharashtra",
          "postalCode": "400001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/mumbai-vadodara-taxi",
        "logo": "https://abghulecabs.com/images/mumbai-vadodara-taxi.jpg",
        "image": "https://abghulecabs.com/images/mumbai-vadodara-taxi.jpg",
        "priceRange": "₹3000 - ₹7000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/mumbai-vadodara-taxi",
          "priceCurrency": "INR",
          "price": "3000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.6",
          "reviewCount": "1200"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vishal Mehta"
            },
            "datePublished": "2024-10-10",
            "reviewBody": "Reliable and affordable taxi service from Mumbai to Vadodara. The ride was smooth, and the driver was professional."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anjali Gupta"
            },
            "datePublished": "2024-09-25",
            "reviewBody": "Excellent service! The one-way taxi from Vadodara to Mumbai was timely, and the driver was courteous. Highly recommended."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Mumbai and Vadodara",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "19.0760",
            "longitude": "72.8777"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/mumbai-vadodara-taxi"
        },
        "keywords": "Mumbai to Vadodara Taxi, Mumbai to Vadodara Cab, Mumbai to Vadodara Taxi Fare, Vadodara to Mumbai Taxi Fare, Vadodara to Mumbai Airport Cab, Vadodara to Mumbai Taxi, One Way Cab Vadodara to Mumbai, Mumbai to Baroda Taxi Fare, Taxi from Mumbai Airport to Vadodara, One Way Taxi from Mumbai to Vadodara, Cab from Vadodara to Mumbai, Vadodara to Mumbai Airport One Way Cab, Mumbai to Vadodara Car Rental, Mumbai to Baroda Cab Price, Mumbai to Baroda One Way Cab, One Way Taxi from Vadodara to Mumbai, Vadodara to Mumbai Car Rental, One Way Cab Vadodara to Mumbai Airport, Vadodara to Mumbai Taxi Service, Pune to Mumbai Taxi Fare, Airport Taxi Mumbai, Best Taxi Service in Mumbai"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/4.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Mumbaitovadodara;